module.exports = __webpack_public_path__ + "img/kitchen.b4d71e17.svg";